/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChangeSerieLayerStateRequest,
  ChangeSerieLayerStateResponse,
  ChangeTermLayerStateRequest,
  ChangeTermLayerStateResponse,
  CreateProductRequest,
  CreateProductResult,
  CreateProjectRequest,
  CreateSerieRequest,
  DeleteDraftTermsResponse,
  GenerateTermsRequest,
  GenerateTermsResponse,
  GetCalculationResponse,
  GetCalendarTermsResponse,
  GetDestinationSeasonOptionsResponse,
  GetPlanningTreeResponse,
  GetProductResponse,
  GetProgramSchemeResponse,
  GetProjectResponse,
  GetSerieCostSchemeTermsResponse,
  GetSerieDetailResponse,
  GetSerieEconomicsResponse,
  GetTermDetailResponse,
  GetTransportFlightPlanRequest,
  GetTransportFlightPlanResponse,
  GetTransportSchemeResponse,
  GetTransportSwapImpactResponse,
  GetVenuaPlannerCalendarTermsParams,
  GetVenuaPlannerDestinationSeasonOptionsParams,
  GetVenuaPlannerTreeParams,
  ListRequest,
  ListResponseOfAvailableLegacyProductSuggestion,
  ListResponseOfDestinationSuggestion,
  ListResponseOfPersonSuggestion,
  ListResponseOfRegularTransportSuggestion,
  PublishSerieResponse,
  ResolveTransportChainRequest,
  ResolveTransportChainResponse,
  SaveCalculationTariffRequest,
  SaveProgramSchemeRequest,
  SaveTransportSchemeRequest,
  UpdateProductRequest,
  UpdateProjectRequest,
  UpdateSerieRequest,
  UpdateTermRequest
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const getVenuaPlannerCalendarTerms = (
    params: GetVenuaPlannerCalendarTermsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetCalendarTermsResponse>(
      {url: `/api/venua-planner/calendar`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetVenuaPlannerCalendarTermsQueryKey = (params?: GetVenuaPlannerCalendarTermsParams,) => {
    return [
    `/api/venua-planner/calendar`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVenuaPlannerCalendarTermsQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError = ErrorType<unknown>>(params: GetVenuaPlannerCalendarTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerCalendarTermsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>> = ({ signal }) => getVenuaPlannerCalendarTerms(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerCalendarTermsQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>>
export type GetVenuaPlannerCalendarTermsQueryError = ErrorType<unknown>


export function useGetVenuaPlannerCalendarTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError = ErrorType<unknown>>(
 params: GetVenuaPlannerCalendarTermsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerCalendarTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError = ErrorType<unknown>>(
 params: GetVenuaPlannerCalendarTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerCalendarTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError = ErrorType<unknown>>(
 params: GetVenuaPlannerCalendarTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerCalendarTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError = ErrorType<unknown>>(
 params: GetVenuaPlannerCalendarTermsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerCalendarTerms>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerCalendarTermsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVenuaPlannerDestinationSeasonOptions = (
    params?: GetVenuaPlannerDestinationSeasonOptionsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetDestinationSeasonOptionsResponse>(
      {url: `/api/venua-planner/destination-seasons`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetVenuaPlannerDestinationSeasonOptionsQueryKey = (params?: GetVenuaPlannerDestinationSeasonOptionsParams,) => {
    return [
    `/api/venua-planner/destination-seasons`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVenuaPlannerDestinationSeasonOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError = ErrorType<unknown>>(params?: GetVenuaPlannerDestinationSeasonOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerDestinationSeasonOptionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>> = ({ signal }) => getVenuaPlannerDestinationSeasonOptions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerDestinationSeasonOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>>
export type GetVenuaPlannerDestinationSeasonOptionsQueryError = ErrorType<unknown>


export function useGetVenuaPlannerDestinationSeasonOptions<TData = Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError = ErrorType<unknown>>(
 params: undefined |  GetVenuaPlannerDestinationSeasonOptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerDestinationSeasonOptions<TData = Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError = ErrorType<unknown>>(
 params?: GetVenuaPlannerDestinationSeasonOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerDestinationSeasonOptions<TData = Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError = ErrorType<unknown>>(
 params?: GetVenuaPlannerDestinationSeasonOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerDestinationSeasonOptions<TData = Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError = ErrorType<unknown>>(
 params?: GetVenuaPlannerDestinationSeasonOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSeasonOptions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerDestinationSeasonOptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVenuaPlannerDestinationSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfDestinationSuggestion>(
      {url: `/api/venua-planner/destinations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetVenuaPlannerDestinationSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getVenuaPlannerDestinationSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getVenuaPlannerDestinationSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetVenuaPlannerDestinationSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>>
    export type GetVenuaPlannerDestinationSuggestionsMutationBody = ListRequest
    export type GetVenuaPlannerDestinationSuggestionsMutationError = ErrorType<unknown>

    export const useGetVenuaPlannerDestinationSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVenuaPlannerDestinationSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetVenuaPlannerDestinationSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerAvailableLegacyProductSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfAvailableLegacyProductSuggestion>(
      {url: `/api/venua-planner/legacy-products/available`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetVenuaPlannerAvailableLegacyProductSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getVenuaPlannerAvailableLegacyProductSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getVenuaPlannerAvailableLegacyProductSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetVenuaPlannerAvailableLegacyProductSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>>
    export type GetVenuaPlannerAvailableLegacyProductSuggestionsMutationBody = ListRequest
    export type GetVenuaPlannerAvailableLegacyProductSuggestionsMutationError = ErrorType<unknown>

    export const useGetVenuaPlannerAvailableLegacyProductSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVenuaPlannerAvailableLegacyProductSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetVenuaPlannerAvailableLegacyProductSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerPersonSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfPersonSuggestion>(
      {url: `/api/venua-planner/persons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetVenuaPlannerPersonSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getVenuaPlannerPersonSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getVenuaPlannerPersonSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetVenuaPlannerPersonSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>>
    export type GetVenuaPlannerPersonSuggestionsMutationBody = ListRequest
    export type GetVenuaPlannerPersonSuggestionsMutationError = ErrorType<unknown>

    export const useGetVenuaPlannerPersonSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVenuaPlannerPersonSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetVenuaPlannerPersonSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateVenuaPlannerProduct = (
    productId: string,
    updateProductRequest: UpdateProductRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateProductRequest
    },
      );
    }
  


export const getUpdateVenuaPlannerProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProduct>>, TError,{productId: string;data: UpdateProductRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProduct>>, TError,{productId: string;data: UpdateProductRequest}, TContext> => {

const mutationKey = ['updateVenuaPlannerProduct'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenuaPlannerProduct>>, {productId: string;data: UpdateProductRequest}> = (props) => {
          const {productId,data} = props ?? {};

          return  updateVenuaPlannerProduct(productId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVenuaPlannerProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenuaPlannerProduct>>>
    export type UpdateVenuaPlannerProductMutationBody = UpdateProductRequest
    export type UpdateVenuaPlannerProductMutationError = ErrorType<unknown>

    export const useUpdateVenuaPlannerProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProduct>>, TError,{productId: string;data: UpdateProductRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVenuaPlannerProduct>>,
        TError,
        {productId: string;data: UpdateProductRequest},
        TContext
      > => {

      const mutationOptions = getUpdateVenuaPlannerProductMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerProduct = (
    productId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProductResponse>(
      {url: `/api/venua-planner/products/${productId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerProductQueryKey = (productId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}`
    ] as const;
    }

    
export const getGetVenuaPlannerProductQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError = ErrorType<void>>(productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerProductQueryKey(productId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerProduct>>> = ({ signal }) => getVenuaPlannerProduct(productId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerProductQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerProduct>>>
export type GetVenuaPlannerProductQueryError = ErrorType<void>


export function useGetVenuaPlannerProduct<TData = Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError = ErrorType<void>>(
 productId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerProduct>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerProduct>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerProduct<TData = Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError = ErrorType<void>>(
 productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerProduct>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerProduct>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerProduct<TData = Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError = ErrorType<void>>(
 productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerProduct<TData = Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError = ErrorType<void>>(
 productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProduct>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerProductQueryOptions(productId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createVenuaPlannerSerie = (
    productId: string,
    createSerieRequest: CreateSerieRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/venua-planner/products/${productId}/series`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSerieRequest, signal
    },
      );
    }
  


export const getCreateVenuaPlannerSerieMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerSerie>>, TError,{productId: string;data: CreateSerieRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerSerie>>, TError,{productId: string;data: CreateSerieRequest}, TContext> => {

const mutationKey = ['createVenuaPlannerSerie'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenuaPlannerSerie>>, {productId: string;data: CreateSerieRequest}> = (props) => {
          const {productId,data} = props ?? {};

          return  createVenuaPlannerSerie(productId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVenuaPlannerSerieMutationResult = NonNullable<Awaited<ReturnType<typeof createVenuaPlannerSerie>>>
    export type CreateVenuaPlannerSerieMutationBody = CreateSerieRequest
    export type CreateVenuaPlannerSerieMutationError = ErrorType<unknown>

    export const useCreateVenuaPlannerSerie = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerSerie>>, TError,{productId: string;data: CreateSerieRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenuaPlannerSerie>>,
        TError,
        {productId: string;data: CreateSerieRequest},
        TContext
      > => {

      const mutationOptions = getCreateVenuaPlannerSerieMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateVenuaPlannerSerie = (
    productId: string,
    serieId: string,
    updateSerieRequest: UpdateSerieRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSerieRequest
    },
      );
    }
  


export const getUpdateVenuaPlannerSerieMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerSerie>>, TError,{productId: string;serieId: string;data: UpdateSerieRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerSerie>>, TError,{productId: string;serieId: string;data: UpdateSerieRequest}, TContext> => {

const mutationKey = ['updateVenuaPlannerSerie'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenuaPlannerSerie>>, {productId: string;serieId: string;data: UpdateSerieRequest}> = (props) => {
          const {productId,serieId,data} = props ?? {};

          return  updateVenuaPlannerSerie(productId,serieId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVenuaPlannerSerieMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenuaPlannerSerie>>>
    export type UpdateVenuaPlannerSerieMutationBody = UpdateSerieRequest
    export type UpdateVenuaPlannerSerieMutationError = ErrorType<unknown>

    export const useUpdateVenuaPlannerSerie = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerSerie>>, TError,{productId: string;serieId: string;data: UpdateSerieRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVenuaPlannerSerie>>,
        TError,
        {productId: string;serieId: string;data: UpdateSerieRequest},
        TContext
      > => {

      const mutationOptions = getUpdateVenuaPlannerSerieMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerSerieDetail = (
    productId: string,
    serieId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetSerieDetailResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerSerieDetailQueryKey = (productId?: string,
    serieId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}`
    ] as const;
    }

    
export const getGetVenuaPlannerSerieDetailQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError = ErrorType<void>>(productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerSerieDetailQueryKey(productId,serieId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>> = ({ signal }) => getVenuaPlannerSerieDetail(productId,serieId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerSerieDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>>
export type GetVenuaPlannerSerieDetailQueryError = ErrorType<void>


export function useGetVenuaPlannerSerieDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerSerieDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerSerieDetailQueryOptions(productId,serieId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVenuaPlannerSerieCalculation = (
    productId: string,
    serieId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetCalculationResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/calculation`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerSerieCalculationQueryKey = (productId?: string,
    serieId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/calculation`
    ] as const;
    }

    
export const getGetVenuaPlannerSerieCalculationQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>, TError = ErrorType<void>>(productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerSerieCalculationQueryKey(productId,serieId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>> = ({ signal }) => getVenuaPlannerSerieCalculation(productId,serieId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerSerieCalculationQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>>
export type GetVenuaPlannerSerieCalculationQueryError = ErrorType<void>


export function useGetVenuaPlannerSerieCalculation<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieCalculation<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieCalculation<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerSerieCalculation<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCalculation>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerSerieCalculationQueryOptions(productId,serieId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const saveVenuaPlannerSerieCalculationTariff = (
    productId: string,
    serieId: string,
    saveCalculationTariffRequest: SaveCalculationTariffRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/calculation/tariff`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveCalculationTariffRequest
    },
      );
    }
  


export const getSaveVenuaPlannerSerieCalculationTariffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerSerieCalculationTariff>>, TError,{productId: string;serieId: string;data: SaveCalculationTariffRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerSerieCalculationTariff>>, TError,{productId: string;serieId: string;data: SaveCalculationTariffRequest}, TContext> => {

const mutationKey = ['saveVenuaPlannerSerieCalculationTariff'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveVenuaPlannerSerieCalculationTariff>>, {productId: string;serieId: string;data: SaveCalculationTariffRequest}> = (props) => {
          const {productId,serieId,data} = props ?? {};

          return  saveVenuaPlannerSerieCalculationTariff(productId,serieId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveVenuaPlannerSerieCalculationTariffMutationResult = NonNullable<Awaited<ReturnType<typeof saveVenuaPlannerSerieCalculationTariff>>>
    export type SaveVenuaPlannerSerieCalculationTariffMutationBody = SaveCalculationTariffRequest
    export type SaveVenuaPlannerSerieCalculationTariffMutationError = ErrorType<unknown>

    export const useSaveVenuaPlannerSerieCalculationTariff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerSerieCalculationTariff>>, TError,{productId: string;serieId: string;data: SaveCalculationTariffRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveVenuaPlannerSerieCalculationTariff>>,
        TError,
        {productId: string;serieId: string;data: SaveCalculationTariffRequest},
        TContext
      > => {

      const mutationOptions = getSaveVenuaPlannerSerieCalculationTariffMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerSerieEconomics = (
    productId: string,
    serieId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetSerieEconomicsResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/economics`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerSerieEconomicsQueryKey = (productId?: string,
    serieId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/economics`
    ] as const;
    }

    
export const getGetVenuaPlannerSerieEconomicsQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError = ErrorType<void>>(productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerSerieEconomicsQueryKey(productId,serieId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>> = ({ signal }) => getVenuaPlannerSerieEconomics(productId,serieId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerSerieEconomicsQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>>
export type GetVenuaPlannerSerieEconomicsQueryError = ErrorType<void>


export function useGetVenuaPlannerSerieEconomics<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieEconomics<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieEconomics<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerSerieEconomics<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieEconomics>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerSerieEconomicsQueryOptions(productId,serieId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const changeVenuaPlannerSerieLayerState = (
    productId: string,
    serieId: string,
    changeSerieLayerStateRequest: ChangeSerieLayerStateRequest,
 ) => {
      
      
      return customInstance<ChangeSerieLayerStateResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/layers/state`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changeSerieLayerStateRequest
    },
      );
    }
  


export const getChangeVenuaPlannerSerieLayerStateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeVenuaPlannerSerieLayerState>>, TError,{productId: string;serieId: string;data: ChangeSerieLayerStateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof changeVenuaPlannerSerieLayerState>>, TError,{productId: string;serieId: string;data: ChangeSerieLayerStateRequest}, TContext> => {

const mutationKey = ['changeVenuaPlannerSerieLayerState'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeVenuaPlannerSerieLayerState>>, {productId: string;serieId: string;data: ChangeSerieLayerStateRequest}> = (props) => {
          const {productId,serieId,data} = props ?? {};

          return  changeVenuaPlannerSerieLayerState(productId,serieId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeVenuaPlannerSerieLayerStateMutationResult = NonNullable<Awaited<ReturnType<typeof changeVenuaPlannerSerieLayerState>>>
    export type ChangeVenuaPlannerSerieLayerStateMutationBody = ChangeSerieLayerStateRequest
    export type ChangeVenuaPlannerSerieLayerStateMutationError = ErrorType<unknown>

    export const useChangeVenuaPlannerSerieLayerState = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeVenuaPlannerSerieLayerState>>, TError,{productId: string;serieId: string;data: ChangeSerieLayerStateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeVenuaPlannerSerieLayerState>>,
        TError,
        {productId: string;serieId: string;data: ChangeSerieLayerStateRequest},
        TContext
      > => {

      const mutationOptions = getChangeVenuaPlannerSerieLayerStateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const saveVenuaPlannerSerieProgramScheme = (
    productId: string,
    serieId: string,
    saveProgramSchemeRequest: SaveProgramSchemeRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/program-scheme`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveProgramSchemeRequest
    },
      );
    }
  


export const getSaveVenuaPlannerSerieProgramSchemeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerSerieProgramScheme>>, TError,{productId: string;serieId: string;data: SaveProgramSchemeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerSerieProgramScheme>>, TError,{productId: string;serieId: string;data: SaveProgramSchemeRequest}, TContext> => {

const mutationKey = ['saveVenuaPlannerSerieProgramScheme'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveVenuaPlannerSerieProgramScheme>>, {productId: string;serieId: string;data: SaveProgramSchemeRequest}> = (props) => {
          const {productId,serieId,data} = props ?? {};

          return  saveVenuaPlannerSerieProgramScheme(productId,serieId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveVenuaPlannerSerieProgramSchemeMutationResult = NonNullable<Awaited<ReturnType<typeof saveVenuaPlannerSerieProgramScheme>>>
    export type SaveVenuaPlannerSerieProgramSchemeMutationBody = SaveProgramSchemeRequest
    export type SaveVenuaPlannerSerieProgramSchemeMutationError = ErrorType<unknown>

    export const useSaveVenuaPlannerSerieProgramScheme = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerSerieProgramScheme>>, TError,{productId: string;serieId: string;data: SaveProgramSchemeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveVenuaPlannerSerieProgramScheme>>,
        TError,
        {productId: string;serieId: string;data: SaveProgramSchemeRequest},
        TContext
      > => {

      const mutationOptions = getSaveVenuaPlannerSerieProgramSchemeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerSerieProgramScheme = (
    productId: string,
    serieId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProgramSchemeResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/program-scheme`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerSerieProgramSchemeQueryKey = (productId?: string,
    serieId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/program-scheme`
    ] as const;
    }

    
export const getGetVenuaPlannerSerieProgramSchemeQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>, TError = ErrorType<void>>(productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerSerieProgramSchemeQueryKey(productId,serieId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>> = ({ signal }) => getVenuaPlannerSerieProgramScheme(productId,serieId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerSerieProgramSchemeQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>>
export type GetVenuaPlannerSerieProgramSchemeQueryError = ErrorType<void>


export function useGetVenuaPlannerSerieProgramScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieProgramScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieProgramScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerSerieProgramScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieProgramScheme>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerSerieProgramSchemeQueryOptions(productId,serieId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVenuaPlannerSerieCostSchemeTerms = (
    productId: string,
    serieId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetSerieCostSchemeTermsResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/program-scheme/terms`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerSerieCostSchemeTermsQueryKey = (productId?: string,
    serieId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/program-scheme/terms`
    ] as const;
    }

    
export const getGetVenuaPlannerSerieCostSchemeTermsQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>, TError = ErrorType<void>>(productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerSerieCostSchemeTermsQueryKey(productId,serieId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>> = ({ signal }) => getVenuaPlannerSerieCostSchemeTerms(productId,serieId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerSerieCostSchemeTermsQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>>
export type GetVenuaPlannerSerieCostSchemeTermsQueryError = ErrorType<void>


export function useGetVenuaPlannerSerieCostSchemeTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieCostSchemeTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieCostSchemeTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerSerieCostSchemeTerms<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieCostSchemeTerms>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerSerieCostSchemeTermsQueryOptions(productId,serieId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const publishVenuaPlannerSerie = (
    productId: string,
    serieId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PublishSerieResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/publish`, method: 'POST', signal
    },
      );
    }
  


export const getPublishVenuaPlannerSerieMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishVenuaPlannerSerie>>, TError,{productId: string;serieId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof publishVenuaPlannerSerie>>, TError,{productId: string;serieId: string}, TContext> => {

const mutationKey = ['publishVenuaPlannerSerie'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishVenuaPlannerSerie>>, {productId: string;serieId: string}> = (props) => {
          const {productId,serieId} = props ?? {};

          return  publishVenuaPlannerSerie(productId,serieId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PublishVenuaPlannerSerieMutationResult = NonNullable<Awaited<ReturnType<typeof publishVenuaPlannerSerie>>>
    
    export type PublishVenuaPlannerSerieMutationError = ErrorType<void>

    export const usePublishVenuaPlannerSerie = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishVenuaPlannerSerie>>, TError,{productId: string;serieId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publishVenuaPlannerSerie>>,
        TError,
        {productId: string;serieId: string},
        TContext
      > => {

      const mutationOptions = getPublishVenuaPlannerSerieMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteVenuaPlannerDraftTerms = (
    productId: string,
    serieId: string,
 ) => {
      
      
      return customInstance<DeleteDraftTermsResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/draft`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteVenuaPlannerDraftTermsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVenuaPlannerDraftTerms>>, TError,{productId: string;serieId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteVenuaPlannerDraftTerms>>, TError,{productId: string;serieId: string}, TContext> => {

const mutationKey = ['deleteVenuaPlannerDraftTerms'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVenuaPlannerDraftTerms>>, {productId: string;serieId: string}> = (props) => {
          const {productId,serieId} = props ?? {};

          return  deleteVenuaPlannerDraftTerms(productId,serieId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVenuaPlannerDraftTermsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVenuaPlannerDraftTerms>>>
    
    export type DeleteVenuaPlannerDraftTermsMutationError = ErrorType<unknown>

    export const useDeleteVenuaPlannerDraftTerms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVenuaPlannerDraftTerms>>, TError,{productId: string;serieId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVenuaPlannerDraftTerms>>,
        TError,
        {productId: string;serieId: string},
        TContext
      > => {

      const mutationOptions = getDeleteVenuaPlannerDraftTermsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const generateVenuaPlannerTerms = (
    productId: string,
    serieId: string,
    generateTermsRequest: GenerateTermsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GenerateTermsResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateTermsRequest, signal
    },
      );
    }
  


export const getGenerateVenuaPlannerTermsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateVenuaPlannerTerms>>, TError,{productId: string;serieId: string;data: GenerateTermsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateVenuaPlannerTerms>>, TError,{productId: string;serieId: string;data: GenerateTermsRequest}, TContext> => {

const mutationKey = ['generateVenuaPlannerTerms'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateVenuaPlannerTerms>>, {productId: string;serieId: string;data: GenerateTermsRequest}> = (props) => {
          const {productId,serieId,data} = props ?? {};

          return  generateVenuaPlannerTerms(productId,serieId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateVenuaPlannerTermsMutationResult = NonNullable<Awaited<ReturnType<typeof generateVenuaPlannerTerms>>>
    export type GenerateVenuaPlannerTermsMutationBody = GenerateTermsRequest
    export type GenerateVenuaPlannerTermsMutationError = ErrorType<unknown>

    export const useGenerateVenuaPlannerTerms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateVenuaPlannerTerms>>, TError,{productId: string;serieId: string;data: GenerateTermsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateVenuaPlannerTerms>>,
        TError,
        {productId: string;serieId: string;data: GenerateTermsRequest},
        TContext
      > => {

      const mutationOptions = getGenerateVenuaPlannerTermsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateVenuaPlannerTerm = (
    productId: string,
    serieId: string,
    termGroupId: string,
    updateTermRequest: UpdateTermRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termGroupId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTermRequest
    },
      );
    }
  


export const getUpdateVenuaPlannerTermMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerTerm>>, TError,{productId: string;serieId: string;termGroupId: string;data: UpdateTermRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerTerm>>, TError,{productId: string;serieId: string;termGroupId: string;data: UpdateTermRequest}, TContext> => {

const mutationKey = ['updateVenuaPlannerTerm'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenuaPlannerTerm>>, {productId: string;serieId: string;termGroupId: string;data: UpdateTermRequest}> = (props) => {
          const {productId,serieId,termGroupId,data} = props ?? {};

          return  updateVenuaPlannerTerm(productId,serieId,termGroupId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVenuaPlannerTermMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenuaPlannerTerm>>>
    export type UpdateVenuaPlannerTermMutationBody = UpdateTermRequest
    export type UpdateVenuaPlannerTermMutationError = ErrorType<unknown>

    export const useUpdateVenuaPlannerTerm = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerTerm>>, TError,{productId: string;serieId: string;termGroupId: string;data: UpdateTermRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVenuaPlannerTerm>>,
        TError,
        {productId: string;serieId: string;termGroupId: string;data: UpdateTermRequest},
        TContext
      > => {

      const mutationOptions = getUpdateVenuaPlannerTermMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerTermDetail = (
    productId: string,
    serieId: string,
    termGroupId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTermDetailResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termGroupId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerTermDetailQueryKey = (productId?: string,
    serieId?: string,
    termGroupId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termGroupId}`
    ] as const;
    }

    
export const getGetVenuaPlannerTermDetailQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>, TError = ErrorType<void>>(productId: string,
    serieId: string,
    termGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerTermDetailQueryKey(productId,serieId,termGroupId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>> = ({ signal }) => getVenuaPlannerTermDetail(productId,serieId,termGroupId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId && termGroupId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerTermDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>>
export type GetVenuaPlannerTermDetailQueryError = ErrorType<void>


export function useGetVenuaPlannerTermDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termGroupId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTermDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTermDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerTermDetail<TData = Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termGroupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerTermDetailQueryOptions(productId,serieId,termGroupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVenuaPlannerTermCalculation = (
    productId: string,
    serieId: string,
    termId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetCalculationResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/calculation`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerTermCalculationQueryKey = (productId?: string,
    serieId?: string,
    termId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/calculation`
    ] as const;
    }

    
export const getGetVenuaPlannerTermCalculationQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>, TError = ErrorType<void>>(productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerTermCalculationQueryKey(productId,serieId,termId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>> = ({ signal }) => getVenuaPlannerTermCalculation(productId,serieId,termId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId && termId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerTermCalculationQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>>
export type GetVenuaPlannerTermCalculationQueryError = ErrorType<void>


export function useGetVenuaPlannerTermCalculation<TData = Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTermCalculation<TData = Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTermCalculation<TData = Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerTermCalculation<TData = Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermCalculation>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerTermCalculationQueryOptions(productId,serieId,termId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const saveVenuaPlannerTermCalculationTariff = (
    productId: string,
    serieId: string,
    termId: string,
    saveCalculationTariffRequest: SaveCalculationTariffRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/calculation/tariff`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveCalculationTariffRequest
    },
      );
    }
  


export const getSaveVenuaPlannerTermCalculationTariffMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerTermCalculationTariff>>, TError,{productId: string;serieId: string;termId: string;data: SaveCalculationTariffRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerTermCalculationTariff>>, TError,{productId: string;serieId: string;termId: string;data: SaveCalculationTariffRequest}, TContext> => {

const mutationKey = ['saveVenuaPlannerTermCalculationTariff'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveVenuaPlannerTermCalculationTariff>>, {productId: string;serieId: string;termId: string;data: SaveCalculationTariffRequest}> = (props) => {
          const {productId,serieId,termId,data} = props ?? {};

          return  saveVenuaPlannerTermCalculationTariff(productId,serieId,termId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveVenuaPlannerTermCalculationTariffMutationResult = NonNullable<Awaited<ReturnType<typeof saveVenuaPlannerTermCalculationTariff>>>
    export type SaveVenuaPlannerTermCalculationTariffMutationBody = SaveCalculationTariffRequest
    export type SaveVenuaPlannerTermCalculationTariffMutationError = ErrorType<unknown>

    export const useSaveVenuaPlannerTermCalculationTariff = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerTermCalculationTariff>>, TError,{productId: string;serieId: string;termId: string;data: SaveCalculationTariffRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveVenuaPlannerTermCalculationTariff>>,
        TError,
        {productId: string;serieId: string;termId: string;data: SaveCalculationTariffRequest},
        TContext
      > => {

      const mutationOptions = getSaveVenuaPlannerTermCalculationTariffMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const changeVenuaPlannerTermLayerState = (
    productId: string,
    serieId: string,
    termId: string,
    changeTermLayerStateRequest: ChangeTermLayerStateRequest,
 ) => {
      
      
      return customInstance<ChangeTermLayerStateResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/layers/state`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changeTermLayerStateRequest
    },
      );
    }
  


export const getChangeVenuaPlannerTermLayerStateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeVenuaPlannerTermLayerState>>, TError,{productId: string;serieId: string;termId: string;data: ChangeTermLayerStateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof changeVenuaPlannerTermLayerState>>, TError,{productId: string;serieId: string;termId: string;data: ChangeTermLayerStateRequest}, TContext> => {

const mutationKey = ['changeVenuaPlannerTermLayerState'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeVenuaPlannerTermLayerState>>, {productId: string;serieId: string;termId: string;data: ChangeTermLayerStateRequest}> = (props) => {
          const {productId,serieId,termId,data} = props ?? {};

          return  changeVenuaPlannerTermLayerState(productId,serieId,termId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeVenuaPlannerTermLayerStateMutationResult = NonNullable<Awaited<ReturnType<typeof changeVenuaPlannerTermLayerState>>>
    export type ChangeVenuaPlannerTermLayerStateMutationBody = ChangeTermLayerStateRequest
    export type ChangeVenuaPlannerTermLayerStateMutationError = ErrorType<unknown>

    export const useChangeVenuaPlannerTermLayerState = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeVenuaPlannerTermLayerState>>, TError,{productId: string;serieId: string;termId: string;data: ChangeTermLayerStateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeVenuaPlannerTermLayerState>>,
        TError,
        {productId: string;serieId: string;termId: string;data: ChangeTermLayerStateRequest},
        TContext
      > => {

      const mutationOptions = getChangeVenuaPlannerTermLayerStateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const saveVenuaPlannerTermProgramScheme = (
    productId: string,
    serieId: string,
    termId: string,
    saveProgramSchemeRequest: SaveProgramSchemeRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/program-scheme`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveProgramSchemeRequest
    },
      );
    }
  


export const getSaveVenuaPlannerTermProgramSchemeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerTermProgramScheme>>, TError,{productId: string;serieId: string;termId: string;data: SaveProgramSchemeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerTermProgramScheme>>, TError,{productId: string;serieId: string;termId: string;data: SaveProgramSchemeRequest}, TContext> => {

const mutationKey = ['saveVenuaPlannerTermProgramScheme'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveVenuaPlannerTermProgramScheme>>, {productId: string;serieId: string;termId: string;data: SaveProgramSchemeRequest}> = (props) => {
          const {productId,serieId,termId,data} = props ?? {};

          return  saveVenuaPlannerTermProgramScheme(productId,serieId,termId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveVenuaPlannerTermProgramSchemeMutationResult = NonNullable<Awaited<ReturnType<typeof saveVenuaPlannerTermProgramScheme>>>
    export type SaveVenuaPlannerTermProgramSchemeMutationBody = SaveProgramSchemeRequest
    export type SaveVenuaPlannerTermProgramSchemeMutationError = ErrorType<unknown>

    export const useSaveVenuaPlannerTermProgramScheme = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerTermProgramScheme>>, TError,{productId: string;serieId: string;termId: string;data: SaveProgramSchemeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveVenuaPlannerTermProgramScheme>>,
        TError,
        {productId: string;serieId: string;termId: string;data: SaveProgramSchemeRequest},
        TContext
      > => {

      const mutationOptions = getSaveVenuaPlannerTermProgramSchemeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerTermProgramScheme = (
    productId: string,
    serieId: string,
    termId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProgramSchemeResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/program-scheme`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerTermProgramSchemeQueryKey = (productId?: string,
    serieId?: string,
    termId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/program-scheme`
    ] as const;
    }

    
export const getGetVenuaPlannerTermProgramSchemeQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>, TError = ErrorType<void>>(productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerTermProgramSchemeQueryKey(productId,serieId,termId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>> = ({ signal }) => getVenuaPlannerTermProgramScheme(productId,serieId,termId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId && termId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerTermProgramSchemeQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>>
export type GetVenuaPlannerTermProgramSchemeQueryError = ErrorType<void>


export function useGetVenuaPlannerTermProgramScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTermProgramScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTermProgramScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerTermProgramScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermProgramScheme>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerTermProgramSchemeQueryOptions(productId,serieId,termId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createVenuaPlannerTermSchemeOverride = (
    productId: string,
    serieId: string,
    termId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/program-scheme/override`, method: 'POST', signal
    },
      );
    }
  


export const getCreateVenuaPlannerTermSchemeOverrideMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerTermSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerTermSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext> => {

const mutationKey = ['createVenuaPlannerTermSchemeOverride'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenuaPlannerTermSchemeOverride>>, {productId: string;serieId: string;termId: string}> = (props) => {
          const {productId,serieId,termId} = props ?? {};

          return  createVenuaPlannerTermSchemeOverride(productId,serieId,termId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVenuaPlannerTermSchemeOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof createVenuaPlannerTermSchemeOverride>>>
    
    export type CreateVenuaPlannerTermSchemeOverrideMutationError = ErrorType<unknown>

    export const useCreateVenuaPlannerTermSchemeOverride = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerTermSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenuaPlannerTermSchemeOverride>>,
        TError,
        {productId: string;serieId: string;termId: string},
        TContext
      > => {

      const mutationOptions = getCreateVenuaPlannerTermSchemeOverrideMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const removeVenuaPlannerTermSchemeOverride = (
    productId: string,
    serieId: string,
    termId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/program-scheme/override`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveVenuaPlannerTermSchemeOverrideMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeVenuaPlannerTermSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeVenuaPlannerTermSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext> => {

const mutationKey = ['removeVenuaPlannerTermSchemeOverride'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeVenuaPlannerTermSchemeOverride>>, {productId: string;serieId: string;termId: string}> = (props) => {
          const {productId,serieId,termId} = props ?? {};

          return  removeVenuaPlannerTermSchemeOverride(productId,serieId,termId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveVenuaPlannerTermSchemeOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof removeVenuaPlannerTermSchemeOverride>>>
    
    export type RemoveVenuaPlannerTermSchemeOverrideMutationError = ErrorType<unknown>

    export const useRemoveVenuaPlannerTermSchemeOverride = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeVenuaPlannerTermSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeVenuaPlannerTermSchemeOverride>>,
        TError,
        {productId: string;serieId: string;termId: string},
        TContext
      > => {

      const mutationOptions = getRemoveVenuaPlannerTermSchemeOverrideMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const saveVenuaPlannerTermTransportScheme = (
    productId: string,
    serieId: string,
    termId: string,
    saveTransportSchemeRequest: SaveTransportSchemeRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/transport-scheme`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveTransportSchemeRequest
    },
      );
    }
  


export const getSaveVenuaPlannerTermTransportSchemeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerTermTransportScheme>>, TError,{productId: string;serieId: string;termId: string;data: SaveTransportSchemeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerTermTransportScheme>>, TError,{productId: string;serieId: string;termId: string;data: SaveTransportSchemeRequest}, TContext> => {

const mutationKey = ['saveVenuaPlannerTermTransportScheme'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveVenuaPlannerTermTransportScheme>>, {productId: string;serieId: string;termId: string;data: SaveTransportSchemeRequest}> = (props) => {
          const {productId,serieId,termId,data} = props ?? {};

          return  saveVenuaPlannerTermTransportScheme(productId,serieId,termId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveVenuaPlannerTermTransportSchemeMutationResult = NonNullable<Awaited<ReturnType<typeof saveVenuaPlannerTermTransportScheme>>>
    export type SaveVenuaPlannerTermTransportSchemeMutationBody = SaveTransportSchemeRequest
    export type SaveVenuaPlannerTermTransportSchemeMutationError = ErrorType<unknown>

    export const useSaveVenuaPlannerTermTransportScheme = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerTermTransportScheme>>, TError,{productId: string;serieId: string;termId: string;data: SaveTransportSchemeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveVenuaPlannerTermTransportScheme>>,
        TError,
        {productId: string;serieId: string;termId: string;data: SaveTransportSchemeRequest},
        TContext
      > => {

      const mutationOptions = getSaveVenuaPlannerTermTransportSchemeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerTermTransportScheme = (
    productId: string,
    serieId: string,
    termId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTransportSchemeResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/transport-scheme`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerTermTransportSchemeQueryKey = (productId?: string,
    serieId?: string,
    termId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/transport-scheme`
    ] as const;
    }

    
export const getGetVenuaPlannerTermTransportSchemeQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>, TError = ErrorType<void>>(productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerTermTransportSchemeQueryKey(productId,serieId,termId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>> = ({ signal }) => getVenuaPlannerTermTransportScheme(productId,serieId,termId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId && termId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerTermTransportSchemeQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>>
export type GetVenuaPlannerTermTransportSchemeQueryError = ErrorType<void>


export function useGetVenuaPlannerTermTransportScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTermTransportScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTermTransportScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerTermTransportScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportScheme>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerTermTransportSchemeQueryOptions(productId,serieId,termId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const resolveVenuaPlannerTermTransportChain = (
    productId: string,
    serieId: string,
    termId: string,
    resolveTransportChainRequest: ResolveTransportChainRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ResolveTransportChainResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/transport-scheme/chain`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resolveTransportChainRequest, signal
    },
      );
    }
  


export const getResolveVenuaPlannerTermTransportChainMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveVenuaPlannerTermTransportChain>>, TError,{productId: string;serieId: string;termId: string;data: ResolveTransportChainRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resolveVenuaPlannerTermTransportChain>>, TError,{productId: string;serieId: string;termId: string;data: ResolveTransportChainRequest}, TContext> => {

const mutationKey = ['resolveVenuaPlannerTermTransportChain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveVenuaPlannerTermTransportChain>>, {productId: string;serieId: string;termId: string;data: ResolveTransportChainRequest}> = (props) => {
          const {productId,serieId,termId,data} = props ?? {};

          return  resolveVenuaPlannerTermTransportChain(productId,serieId,termId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResolveVenuaPlannerTermTransportChainMutationResult = NonNullable<Awaited<ReturnType<typeof resolveVenuaPlannerTermTransportChain>>>
    export type ResolveVenuaPlannerTermTransportChainMutationBody = ResolveTransportChainRequest
    export type ResolveVenuaPlannerTermTransportChainMutationError = ErrorType<void>

    export const useResolveVenuaPlannerTermTransportChain = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveVenuaPlannerTermTransportChain>>, TError,{productId: string;serieId: string;termId: string;data: ResolveTransportChainRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resolveVenuaPlannerTermTransportChain>>,
        TError,
        {productId: string;serieId: string;termId: string;data: ResolveTransportChainRequest},
        TContext
      > => {

      const mutationOptions = getResolveVenuaPlannerTermTransportChainMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerTermTransportFlightPlan = (
    productId: string,
    serieId: string,
    termId: string,
    getTransportFlightPlanRequest: GetTransportFlightPlanRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTransportFlightPlanResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/transport-scheme/flight-plan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getTransportFlightPlanRequest, signal
    },
      );
    }
  


export const getGetVenuaPlannerTermTransportFlightPlanMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportFlightPlan>>, TError,{productId: string;serieId: string;termId: string;data: GetTransportFlightPlanRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportFlightPlan>>, TError,{productId: string;serieId: string;termId: string;data: GetTransportFlightPlanRequest}, TContext> => {

const mutationKey = ['getVenuaPlannerTermTransportFlightPlan'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVenuaPlannerTermTransportFlightPlan>>, {productId: string;serieId: string;termId: string;data: GetTransportFlightPlanRequest}> = (props) => {
          const {productId,serieId,termId,data} = props ?? {};

          return  getVenuaPlannerTermTransportFlightPlan(productId,serieId,termId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetVenuaPlannerTermTransportFlightPlanMutationResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerTermTransportFlightPlan>>>
    export type GetVenuaPlannerTermTransportFlightPlanMutationBody = GetTransportFlightPlanRequest
    export type GetVenuaPlannerTermTransportFlightPlanMutationError = ErrorType<void>

    export const useGetVenuaPlannerTermTransportFlightPlan = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportFlightPlan>>, TError,{productId: string;serieId: string;termId: string;data: GetTransportFlightPlanRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVenuaPlannerTermTransportFlightPlan>>,
        TError,
        {productId: string;serieId: string;termId: string;data: GetTransportFlightPlanRequest},
        TContext
      > => {

      const mutationOptions = getGetVenuaPlannerTermTransportFlightPlanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const createVenuaPlannerTermTransportSchemeOverride = (
    productId: string,
    serieId: string,
    termId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/transport-scheme/override`, method: 'POST', signal
    },
      );
    }
  


export const getCreateVenuaPlannerTermTransportSchemeOverrideMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerTermTransportSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerTermTransportSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext> => {

const mutationKey = ['createVenuaPlannerTermTransportSchemeOverride'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenuaPlannerTermTransportSchemeOverride>>, {productId: string;serieId: string;termId: string}> = (props) => {
          const {productId,serieId,termId} = props ?? {};

          return  createVenuaPlannerTermTransportSchemeOverride(productId,serieId,termId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVenuaPlannerTermTransportSchemeOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof createVenuaPlannerTermTransportSchemeOverride>>>
    
    export type CreateVenuaPlannerTermTransportSchemeOverrideMutationError = ErrorType<unknown>

    export const useCreateVenuaPlannerTermTransportSchemeOverride = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerTermTransportSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenuaPlannerTermTransportSchemeOverride>>,
        TError,
        {productId: string;serieId: string;termId: string},
        TContext
      > => {

      const mutationOptions = getCreateVenuaPlannerTermTransportSchemeOverrideMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const removeVenuaPlannerTermTransportSchemeOverride = (
    productId: string,
    serieId: string,
    termId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/transport-scheme/override`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveVenuaPlannerTermTransportSchemeOverrideMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeVenuaPlannerTermTransportSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeVenuaPlannerTermTransportSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext> => {

const mutationKey = ['removeVenuaPlannerTermTransportSchemeOverride'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeVenuaPlannerTermTransportSchemeOverride>>, {productId: string;serieId: string;termId: string}> = (props) => {
          const {productId,serieId,termId} = props ?? {};

          return  removeVenuaPlannerTermTransportSchemeOverride(productId,serieId,termId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveVenuaPlannerTermTransportSchemeOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof removeVenuaPlannerTermTransportSchemeOverride>>>
    
    export type RemoveVenuaPlannerTermTransportSchemeOverrideMutationError = ErrorType<unknown>

    export const useRemoveVenuaPlannerTermTransportSchemeOverride = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeVenuaPlannerTermTransportSchemeOverride>>, TError,{productId: string;serieId: string;termId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeVenuaPlannerTermTransportSchemeOverride>>,
        TError,
        {productId: string;serieId: string;termId: string},
        TContext
      > => {

      const mutationOptions = getRemoveVenuaPlannerTermTransportSchemeOverrideMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerTermTransportSwapImpact = (
    productId: string,
    serieId: string,
    termId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTransportSwapImpactResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/transport-scheme/swap-impact`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerTermTransportSwapImpactQueryKey = (productId?: string,
    serieId?: string,
    termId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/terms/${termId}/transport-scheme/swap-impact`
    ] as const;
    }

    
export const getGetVenuaPlannerTermTransportSwapImpactQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>, TError = ErrorType<void>>(productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerTermTransportSwapImpactQueryKey(productId,serieId,termId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>> = ({ signal }) => getVenuaPlannerTermTransportSwapImpact(productId,serieId,termId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId && termId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerTermTransportSwapImpactQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>>
export type GetVenuaPlannerTermTransportSwapImpactQueryError = ErrorType<void>


export function useGetVenuaPlannerTermTransportSwapImpact<TData = Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTermTransportSwapImpact<TData = Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTermTransportSwapImpact<TData = Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerTermTransportSwapImpact<TData = Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string,
    termId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTermTransportSwapImpact>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerTermTransportSwapImpactQueryOptions(productId,serieId,termId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const saveVenuaPlannerSerieTransportScheme = (
    productId: string,
    serieId: string,
    saveTransportSchemeRequest: SaveTransportSchemeRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/transport-scheme`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveTransportSchemeRequest
    },
      );
    }
  


export const getSaveVenuaPlannerSerieTransportSchemeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerSerieTransportScheme>>, TError,{productId: string;serieId: string;data: SaveTransportSchemeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerSerieTransportScheme>>, TError,{productId: string;serieId: string;data: SaveTransportSchemeRequest}, TContext> => {

const mutationKey = ['saveVenuaPlannerSerieTransportScheme'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveVenuaPlannerSerieTransportScheme>>, {productId: string;serieId: string;data: SaveTransportSchemeRequest}> = (props) => {
          const {productId,serieId,data} = props ?? {};

          return  saveVenuaPlannerSerieTransportScheme(productId,serieId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveVenuaPlannerSerieTransportSchemeMutationResult = NonNullable<Awaited<ReturnType<typeof saveVenuaPlannerSerieTransportScheme>>>
    export type SaveVenuaPlannerSerieTransportSchemeMutationBody = SaveTransportSchemeRequest
    export type SaveVenuaPlannerSerieTransportSchemeMutationError = ErrorType<unknown>

    export const useSaveVenuaPlannerSerieTransportScheme = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveVenuaPlannerSerieTransportScheme>>, TError,{productId: string;serieId: string;data: SaveTransportSchemeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveVenuaPlannerSerieTransportScheme>>,
        TError,
        {productId: string;serieId: string;data: SaveTransportSchemeRequest},
        TContext
      > => {

      const mutationOptions = getSaveVenuaPlannerSerieTransportSchemeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerSerieTransportScheme = (
    productId: string,
    serieId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTransportSchemeResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/transport-scheme`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerSerieTransportSchemeQueryKey = (productId?: string,
    serieId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/transport-scheme`
    ] as const;
    }

    
export const getGetVenuaPlannerSerieTransportSchemeQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>, TError = ErrorType<void>>(productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerSerieTransportSchemeQueryKey(productId,serieId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>> = ({ signal }) => getVenuaPlannerSerieTransportScheme(productId,serieId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerSerieTransportSchemeQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>>
export type GetVenuaPlannerSerieTransportSchemeQueryError = ErrorType<void>


export function useGetVenuaPlannerSerieTransportScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieTransportScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieTransportScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerSerieTransportScheme<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportScheme>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerSerieTransportSchemeQueryOptions(productId,serieId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const resolveVenuaPlannerSerieTransportChain = (
    productId: string,
    serieId: string,
    resolveTransportChainRequest: ResolveTransportChainRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ResolveTransportChainResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/transport-scheme/chain`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resolveTransportChainRequest, signal
    },
      );
    }
  


export const getResolveVenuaPlannerSerieTransportChainMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveVenuaPlannerSerieTransportChain>>, TError,{productId: string;serieId: string;data: ResolveTransportChainRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resolveVenuaPlannerSerieTransportChain>>, TError,{productId: string;serieId: string;data: ResolveTransportChainRequest}, TContext> => {

const mutationKey = ['resolveVenuaPlannerSerieTransportChain'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveVenuaPlannerSerieTransportChain>>, {productId: string;serieId: string;data: ResolveTransportChainRequest}> = (props) => {
          const {productId,serieId,data} = props ?? {};

          return  resolveVenuaPlannerSerieTransportChain(productId,serieId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResolveVenuaPlannerSerieTransportChainMutationResult = NonNullable<Awaited<ReturnType<typeof resolveVenuaPlannerSerieTransportChain>>>
    export type ResolveVenuaPlannerSerieTransportChainMutationBody = ResolveTransportChainRequest
    export type ResolveVenuaPlannerSerieTransportChainMutationError = ErrorType<void>

    export const useResolveVenuaPlannerSerieTransportChain = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveVenuaPlannerSerieTransportChain>>, TError,{productId: string;serieId: string;data: ResolveTransportChainRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resolveVenuaPlannerSerieTransportChain>>,
        TError,
        {productId: string;serieId: string;data: ResolveTransportChainRequest},
        TContext
      > => {

      const mutationOptions = getResolveVenuaPlannerSerieTransportChainMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerSerieTransportFlightPlan = (
    productId: string,
    serieId: string,
    getTransportFlightPlanRequest: GetTransportFlightPlanRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTransportFlightPlanResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/transport-scheme/flight-plan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getTransportFlightPlanRequest, signal
    },
      );
    }
  


export const getGetVenuaPlannerSerieTransportFlightPlanMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportFlightPlan>>, TError,{productId: string;serieId: string;data: GetTransportFlightPlanRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportFlightPlan>>, TError,{productId: string;serieId: string;data: GetTransportFlightPlanRequest}, TContext> => {

const mutationKey = ['getVenuaPlannerSerieTransportFlightPlan'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportFlightPlan>>, {productId: string;serieId: string;data: GetTransportFlightPlanRequest}> = (props) => {
          const {productId,serieId,data} = props ?? {};

          return  getVenuaPlannerSerieTransportFlightPlan(productId,serieId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetVenuaPlannerSerieTransportFlightPlanMutationResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportFlightPlan>>>
    export type GetVenuaPlannerSerieTransportFlightPlanMutationBody = GetTransportFlightPlanRequest
    export type GetVenuaPlannerSerieTransportFlightPlanMutationError = ErrorType<void>

    export const useGetVenuaPlannerSerieTransportFlightPlan = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportFlightPlan>>, TError,{productId: string;serieId: string;data: GetTransportFlightPlanRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVenuaPlannerSerieTransportFlightPlan>>,
        TError,
        {productId: string;serieId: string;data: GetTransportFlightPlanRequest},
        TContext
      > => {

      const mutationOptions = getGetVenuaPlannerSerieTransportFlightPlanMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerSerieTransportSwapImpact = (
    productId: string,
    serieId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetTransportSwapImpactResponse>(
      {url: `/api/venua-planner/products/${productId}/series/${serieId}/transport-scheme/swap-impact`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerSerieTransportSwapImpactQueryKey = (productId?: string,
    serieId?: string,) => {
    return [
    `/api/venua-planner/products/${productId}/series/${serieId}/transport-scheme/swap-impact`
    ] as const;
    }

    
export const getGetVenuaPlannerSerieTransportSwapImpactQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>, TError = ErrorType<void>>(productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerSerieTransportSwapImpactQueryKey(productId,serieId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>> = ({ signal }) => getVenuaPlannerSerieTransportSwapImpact(productId,serieId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productId && serieId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerSerieTransportSwapImpactQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>>
export type GetVenuaPlannerSerieTransportSwapImpactQueryError = ErrorType<void>


export function useGetVenuaPlannerSerieTransportSwapImpact<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieTransportSwapImpact<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerSerieTransportSwapImpact<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerSerieTransportSwapImpact<TData = Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>, TError = ErrorType<void>>(
 productId: string,
    serieId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerSerieTransportSwapImpact>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerSerieTransportSwapImpactQueryOptions(productId,serieId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createVenuaPlannerProject = (
    createProjectRequest: CreateProjectRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/venua-planner/projects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProjectRequest, signal
    },
      );
    }
  


export const getCreateVenuaPlannerProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProject>>, TError,{data: CreateProjectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProject>>, TError,{data: CreateProjectRequest}, TContext> => {

const mutationKey = ['createVenuaPlannerProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenuaPlannerProject>>, {data: CreateProjectRequest}> = (props) => {
          const {data} = props ?? {};

          return  createVenuaPlannerProject(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVenuaPlannerProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createVenuaPlannerProject>>>
    export type CreateVenuaPlannerProjectMutationBody = CreateProjectRequest
    export type CreateVenuaPlannerProjectMutationError = ErrorType<unknown>

    export const useCreateVenuaPlannerProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProject>>, TError,{data: CreateProjectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenuaPlannerProject>>,
        TError,
        {data: CreateProjectRequest},
        TContext
      > => {

      const mutationOptions = getCreateVenuaPlannerProjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateVenuaPlannerProject = (
    projectId: string,
    updateProjectRequest: UpdateProjectRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/projects/${projectId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateProjectRequest
    },
      );
    }
  


export const getUpdateVenuaPlannerProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProject>>, TError,{projectId: string;data: UpdateProjectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProject>>, TError,{projectId: string;data: UpdateProjectRequest}, TContext> => {

const mutationKey = ['updateVenuaPlannerProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenuaPlannerProject>>, {projectId: string;data: UpdateProjectRequest}> = (props) => {
          const {projectId,data} = props ?? {};

          return  updateVenuaPlannerProject(projectId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVenuaPlannerProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenuaPlannerProject>>>
    export type UpdateVenuaPlannerProjectMutationBody = UpdateProjectRequest
    export type UpdateVenuaPlannerProjectMutationError = ErrorType<unknown>

    export const useUpdateVenuaPlannerProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenuaPlannerProject>>, TError,{projectId: string;data: UpdateProjectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVenuaPlannerProject>>,
        TError,
        {projectId: string;data: UpdateProjectRequest},
        TContext
      > => {

      const mutationOptions = getUpdateVenuaPlannerProjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerProject = (
    projectId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetProjectResponse>(
      {url: `/api/venua-planner/projects/${projectId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetVenuaPlannerProjectQueryKey = (projectId?: string,) => {
    return [
    `/api/venua-planner/projects/${projectId}`
    ] as const;
    }

    
export const getGetVenuaPlannerProjectQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError = ErrorType<void>>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerProjectQueryKey(projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerProject>>> = ({ signal }) => getVenuaPlannerProject(projectId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerProject>>>
export type GetVenuaPlannerProjectQueryError = ErrorType<void>


export function useGetVenuaPlannerProject<TData = Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError = ErrorType<void>>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerProject>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerProject>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerProject<TData = Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError = ErrorType<void>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerProject>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerProject>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerProject<TData = Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError = ErrorType<void>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerProject<TData = Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError = ErrorType<void>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerProject>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerProjectQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const archiveVenuaPlannerProject = (
    projectId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/projects/${projectId}/archive`, method: 'POST', signal
    },
      );
    }
  


export const getArchiveVenuaPlannerProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveVenuaPlannerProject>>, TError,{projectId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveVenuaPlannerProject>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['archiveVenuaPlannerProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveVenuaPlannerProject>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  archiveVenuaPlannerProject(projectId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArchiveVenuaPlannerProjectMutationResult = NonNullable<Awaited<ReturnType<typeof archiveVenuaPlannerProject>>>
    
    export type ArchiveVenuaPlannerProjectMutationError = ErrorType<unknown>

    export const useArchiveVenuaPlannerProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveVenuaPlannerProject>>, TError,{projectId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveVenuaPlannerProject>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getArchiveVenuaPlannerProjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const createVenuaPlannerProduct = (
    projectId: string,
    createProductRequest: CreateProductRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CreateProductResult>(
      {url: `/api/venua-planner/projects/${projectId}/products`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProductRequest, signal
    },
      );
    }
  


export const getCreateVenuaPlannerProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProduct>>, TError,{projectId: string;data: CreateProductRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProduct>>, TError,{projectId: string;data: CreateProductRequest}, TContext> => {

const mutationKey = ['createVenuaPlannerProduct'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenuaPlannerProduct>>, {projectId: string;data: CreateProductRequest}> = (props) => {
          const {projectId,data} = props ?? {};

          return  createVenuaPlannerProduct(projectId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVenuaPlannerProductMutationResult = NonNullable<Awaited<ReturnType<typeof createVenuaPlannerProduct>>>
    export type CreateVenuaPlannerProductMutationBody = CreateProductRequest
    export type CreateVenuaPlannerProductMutationError = ErrorType<unknown>

    export const useCreateVenuaPlannerProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenuaPlannerProduct>>, TError,{projectId: string;data: CreateProductRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenuaPlannerProduct>>,
        TError,
        {projectId: string;data: CreateProductRequest},
        TContext
      > => {

      const mutationOptions = getCreateVenuaPlannerProductMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const unarchiveVenuaPlannerProject = (
    projectId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/venua-planner/projects/${projectId}/unarchive`, method: 'POST', signal
    },
      );
    }
  


export const getUnarchiveVenuaPlannerProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>, TError,{projectId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['unarchiveVenuaPlannerProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  unarchiveVenuaPlannerProject(projectId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveVenuaPlannerProjectMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>>
    
    export type UnarchiveVenuaPlannerProjectMutationError = ErrorType<unknown>

    export const useUnarchiveVenuaPlannerProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>, TError,{projectId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unarchiveVenuaPlannerProject>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getUnarchiveVenuaPlannerProjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerRegularTransportSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfRegularTransportSuggestion>(
      {url: `/api/venua-planner/regular-transports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetVenuaPlannerRegularTransportSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getVenuaPlannerRegularTransportSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getVenuaPlannerRegularTransportSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetVenuaPlannerRegularTransportSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>>
    export type GetVenuaPlannerRegularTransportSuggestionsMutationBody = ListRequest
    export type GetVenuaPlannerRegularTransportSuggestionsMutationError = ErrorType<unknown>

    export const useGetVenuaPlannerRegularTransportSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVenuaPlannerRegularTransportSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetVenuaPlannerRegularTransportSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getVenuaPlannerTree = (
    params?: GetVenuaPlannerTreeParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetPlanningTreeResponse>(
      {url: `/api/venua-planner/tree`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetVenuaPlannerTreeQueryKey = (params?: GetVenuaPlannerTreeParams,) => {
    return [
    `/api/venua-planner/tree`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetVenuaPlannerTreeQueryOptions = <TData = Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError = ErrorType<unknown>>(params?: GetVenuaPlannerTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenuaPlannerTreeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenuaPlannerTree>>> = ({ signal }) => getVenuaPlannerTree(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVenuaPlannerTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getVenuaPlannerTree>>>
export type GetVenuaPlannerTreeQueryError = ErrorType<unknown>


export function useGetVenuaPlannerTree<TData = Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetVenuaPlannerTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTree>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTree>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTree<TData = Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError = ErrorType<unknown>>(
 params?: GetVenuaPlannerTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVenuaPlannerTree>>,
          TError,
          Awaited<ReturnType<typeof getVenuaPlannerTree>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVenuaPlannerTree<TData = Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError = ErrorType<unknown>>(
 params?: GetVenuaPlannerTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVenuaPlannerTree<TData = Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError = ErrorType<unknown>>(
 params?: GetVenuaPlannerTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVenuaPlannerTree>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVenuaPlannerTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




